var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('div',{staticClass:"loading_con"},[_c('div',{staticClass:"loading-blue"}),_c('div',[_c('img',{attrs:{"src":require("@assets/loading.png"),"alt":""}})]),_c('div',{staticClass:"loadingText"},[_vm._v("努力加载中...")])])])
}]

export { render, staticRenderFns }